export default __webpack_public_path__ + "static/mobile-app-e3b58067e723a5031dc130cb959063b0.png";